module.exports = __webpack_public_path__ + "img/photo_info_bg.cc700bad.png";